export enum FrameGauge {
  _16 = '16 Gauge',
  _14 = '14 Gauge',
}
